import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import BackButton from "../components/common/BackButton";
import CustomiseSection from "../components/collection/CustomiseSection";

// 1. The Individual Product Card Component
const EmbroideryCard = ({ product, onViewClick }) => {
    const [loupePos, setLoupePos] = useState({ x: 0, y: 0 });
    const [imagePos, setImagePos] = useState({ x: 0, y: 0 });
    const imageWrapperRef = useRef(null);

    // This function calculates the mouse position relative to the image container
    // and updates the position of the loupe circle and the image inside it.
    const handleMouseMove = (e) => {
        const { left, top, width, height } =
            imageWrapperRef.current.getBoundingClientRect();

        // Mouse coordinates relative to the wrapper
        const x = e.clientX - left;
        const y = e.clientY - top;

        // Update Loupe Position (centered on mouse)
        setLoupePos({ x, y });

        // Update magnified image position *inside* the loupe.
        // New Formula:
        // We want the point (x, y) on the small image to correspond to the center of the loupe.
        // The large image is at -x * scale, -y * scale relative to the origin.
        // We add loupeRadius to center that 'view' in the loupe div.

        const scale = 2.8; // Matches CSS width: 250%
        const loupeRadius = 90; // Matches CSS width/height: 180px / 2 = 90

        setImagePos({
            x: -(x * scale) + loupeRadius,
            y: -(y * scale) + loupeRadius,
        });
    };

    return (
        <div className="pe-card-wrapper">
            <div className="pe-card pe-static-card">
                {/* --- Image Wrapper with Mouse Tracking --- */}
                <div
                    className="pe-image-wrapper"
                    ref={imageWrapperRef}
                    onMouseMove={handleMouseMove}
                // On mouse leave, maybe reset? Optional, but feels smoother if left as is.
                >
                    {/* The "Base" Photo (Flat) */}
                    <img
                        src={product.imageBase}
                        alt={product.title}
                        className="pe-base-image"
                    />

                    {/* The Magnifying Loupe Circle */}
                    <div
                        className="pe-loupe"
                        style={{ top: `${loupePos.y}px`, left: `${loupePos.x}px` }}
                    >
                        {/* The "Textured" Embroidery Image inside the loupe */}
                        <img
                            src={product.imageTexture}
                            alt="Embroidery Detail"
                            className="pe-loupe-image"
                            style={{
                                transform: `translate(${imagePos.x}px, ${imagePos.y}px)`,
                            }}
                        />
                    </div>
                </div>

                {/* --- Card Details --- */}
                <div className="pe-details">
                    {/* Replaced Category with ID */}
                    {/* <span className="pe-category">PRODUCT ID: {product.id}</span> */}
                    <h3 className="pe-title">{product.title}</h3>

                    <div className="pe-button-container">
                        <button className="pe-btn" onClick={() => onViewClick(product.route)}>View Options</button>
                    </div>
                </div>
            </div>
        </div>
    );
};




// 2. Main Container displaying the grid
export default function HandcraftedAccessories() {
    const navigate = useNavigate();
    // DUMMY DATA - Replace with your real data
    // IMPT: Use real, high-res embroidery closeups for 'imageTexture'
    const products = [
        {
            id: 'S-01',
            category: "Shirts & Skirts",
            title: "Shirts & Skirts",
            price: "₹ 2,499",
            imageBase: "images/acc3.webp", // Flat photo
            imageTexture: "images/acc3.webp", // Detailed texture (stand-in)
            route: "/shirts"
        },
        {
            id: 'K-02',
            category: "KeyCharms",
            title: "KeyCharms",
            price: "₹ 2,499",
            imageBase: "images/acc6.webp",
            imageTexture: "images/acc6.webp", // Texture stand-in
            route: "/keychains"
        },
        {
            id: 'H-03',
            category: "Hankies",
            title: "Hankies ",
            price: "₹ 2,499",
            imageBase: "images/acc5.webp", // Flat photo
            imageTexture: "images/acc5.webp", // Detailed texture (stand-in)
            route: "/hankies"
        },
        {
            id: 'G-04',
            category: "Gadget Accessories",
            title: "Gadget Accessories",
            price: "₹ 2,499",
            imageBase: "images/acc4.webp", // Flat photo
            imageTexture: "images/acc4.webp", // Detailed texture (stand-in)
            route: "/gadget-accessories"
        },
        {
            id: 'D-05',
            category: "Diary",
            title: "Handmade Diary",
            price: "₹ 2,499",
            imageBase: "images/diary.webp", // Flat photo
            imageTexture: "images/diary.webp", // Detailed texture (stand-in)
            route: "/diary"
        },
    ];

    const handleViewProduct = (route) => {
        navigate(route);
    };

    return (
        <>
            <section className="pe-section" style={{ paddingBottom: '120px' }}>
                <div style={{ padding: "0 5%", maxWidth: "1200px", margin: "0 auto", marginTop: "20px" }}>
                    <BackButton />
                </div>
                <div className="pe-header">
                    <h2 className="pe-main-title">❖ Hand Crafted Accessories ❖</h2>
                    <div className="pe-thread-line"></div>
                    <p className="pe-subtitle">
                        Thoughtfully handcrafted accessories for modern living.
                        Every stitch adds personality.
                    </p>
                </div>

                <div className="pe-grid">
                    {products.map((product) => (
                        <EmbroideryCard key={product.id} product={product} onViewClick={handleViewProduct} />
                    ))}

                </div>
            </section>
            <CustomiseSection />
        </>
    );
}